import { toast } from "react-toastify";
import './toastUtils.css'

const ToastTimeout = 2500;

export const showSuccessToast = (message: string): void => {
  toast.success(message, {
    position: "bottom-center",
    autoClose: ToastTimeout,
  });
};


//For Mobile
export const showErrorToast = (message: string): void => {
  toast.error(message, {
    //  position: "top-right",
    autoClose: ToastTimeout,

    style: {
      backgroundColor: "var(--primary-color)",  
      color: "var(--primary-text-color) !important",
      fontWeight: "bold",
      borderRadius: "8px",
      fontSize: "14px",
      zIndex:9999,
      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    },
  });
};


//For Desktop
export const showErrorToastDesktop = (message: string): void => {
  toast.error(message, {
    position: "top-right",
    autoClose: ToastTimeout,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    className: "custom-toast-container-desktop",

    style: {
      backgroundColor: "var(--primary-color)",  
      color: "var(--primary-text-color)",
      fontWeight: "bold",
      borderRadius: "8px",
      padding: "12px 16px",
      fontSize: "14px",
      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    },
  });
};
